<template>
  <div style="height: 100vh;" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div>
      <div>
        <div>
          <div :class="header == true ? 'block' : 'block1'" style="    display: flex;justify-content: space-between;width: 100%;height:60px">
            <div id="form" style="margin-top: 16px; margin-left: 11px;    display: flex; height: 30px;">
                <span @click="cleanUpEvt" class="all_text">All</span>

                <div @click="tnachuang" style=" line-height: 26px;  width: 80px;height: 26px;cursor: pointer;display: flex; border:1px solid #b3b7bc;margin-left:10px;justify-content: center;border-radius: 5px;margin-right: 10px;">
                    <span  style="font-size: 13px;color:#787373" >Filter</span>
                </div>
                
                <el-date-picker v-if="value2 && value2.length" v-model="value2" type="daterange" start-placeholder="开始日期" value-format="timestamp"
                end-placeholder="结束日期" align="right" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd"
                range-separator="-" style="width: 240px;margin-left:5px" @change="getList"
                :class="{ 'your-css-class_box': !isValue2Empty_box }" class="border_box">
                </el-date-picker>
                <el-dropdown @command="RechargeEvt" class="num_box " style="margin:0 5px" v-show="RechargeName !== '请选择'">
                <el-button type="primary" size="mini" :class="RechargeName !== '请选择' ? 'vip-button' : 'selt'">
                    {{ RechargeName }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                    <i class="el-icon-circle-close clear_ev" @click="clearEvt1" v-show="RechargeName !== '请选择'"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="4">会员购买</el-dropdown-item>
                    <el-dropdown-item command="5">购买点数</el-dropdown-item>
                    <el-dropdown-item command="6">AI充值</el-dropdown-item>
                </el-dropdown-menu>
                </el-dropdown>
                <el-input v-if="username" style="width: 80px;margin-left:5px" size="mini" placeholder="作者" v-model="username" clearable
                @change="getList"  :class="{ 'vip': username && username.length != '0' }" ></el-input>
            </div>

            <div class="pagination_box">
              <el-input v-model="paginationInput" style="width: 50px" size="mini" @change="limitEvt"
                placeholder="to"></el-input>

              <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage1"
                :page-size="paginationInput - 0" layout="prev, pager, next, jumper" :total="zonghe" :pager-count="5"
                :show-total="showTotal"></el-pagination>
            </div>
          </div>
        </div>

        <div style="margin-top: 60px;overflow: unset;border-bottom: 1px solid #e1e1e1; margin-top: 1px solid #e1e1e1;">
          <el-table ref="sortTable" :data="tableData" :cell-style="rowStyle" :summary-method="getSummaries" height="55%"
            :empty-text="dataLoaded ? '暂无数据' : '正在加载数据中...'" @sort-change="sortChangeEvt" show-summary
            style="width: 100%; margin-top: 43px; overflow: none;font-size:12px">
            <!-- <el-table-column type="vlo" width="55"> </el-table-column> -->
            <el-table-column sortable="custom" prop="order_time" label="收入时间" width="100" align="left" label-class-name="source_ID">
                <template slot-scope="props">
                    <span style="width:70px;display:flex;text-align: left;margin-left:15px;" >{{ props.row.order_time }}</span>
                </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="amount_total" width="100" label="收入金额" align="center">
            </el-table-column>
            <el-table-column sortable="custom" prop="expire_time" width="150" label="有效期" align="left" label-class-name="source_ID">
                <template slot-scope="props">
                    <span style="width:70px;display:flex;text-align: left;margin-left:15px;" >{{ props.row.expire_time }}</span>
                </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="" width="120" label="头像" align="center">
                <template slot-scope="props">
                    <div style="display: flex;flex-direction: column; text-align: left;align-items: center;">
                        <el-avatar :src="props.row.header_img"></el-avatar>
                        <span>{{ props.row.username }}</span>
                    </div>
                </template>
            </el-table-column>
           
            <el-table-column sortable="custom" prop="remark" label="备注" width="180" align="left" >
              <template slot-scope="props">
                <div class="notes_box">
                  <el-input ref="editInput" v-if="props.row.id === editShowInp" v-model="props.row.remark"
                  @keyup.enter.native="saveRemark(props.row.id)" 
                  @blur.stop="saveRemark(props.row.id)"  placeholder="请输入内容"></el-input>
                  <div class="name_box" @click="editShowEvt(props.row, 'remark')" v-else>
                    <span style="height: 72px; line-height: 72px">{{
                      props.row.remark
                      }}</span>
                    <i class="el-icon-edit"></i>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="recharge_count" width="220" label="该板块充值次数 " align="center">
              <template slot-scope="props">
                <span :style="{ color: props.row.recharge_count == 0 ? '#d1d1d1' : '#333' }">{{ props.row.recharge_count }}</span>
              </template>
            </el-table-column>

            <!-- <el-table-column sortable="custom" prop="recharge_count" width="140" label="该板块充值金额" align="center">
              <template slot-scope="props">
                <span :style="{ color: props.row.recharge_count == 0 ? '#d1d1d1' : '#333' }">{{ props.row.recharge_count }}</span>

              </template>
            </el-table-column> -->

            <el-table-column sortable="custom" prop="vip_level" width="160" label="参考图身份" align="center">
                <template slot-scope="scope">
                    <!-- 定义映射对象，key是身份值，value包含文字和颜色 -->
                    <span :style="{ color: {1:'#000',2:'#f56c6c',3:'#c0c4cc'}[scope.row.vip_level] || '#c0c4cc' }">
                    {{ {1:'会员中',2:'已过期',3:'非会员'}[scope.row.vip_level] || '非会员' }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="ai_level" width="160" label="AI身份" align="center">
                <template slot-scope="scope">
                    <!-- 定义映射对象，key是身份值，value包含文字和颜色 -->
                    <span :style="{ color: {1:'#000',2:'#f56c6c',3:'#c0c4cc'}[scope.row.ai_level] || '#c0c4cc' }">
                    {{ {1:'会员中',2:'已过期',3:'非会员'}[scope.row.ai_level] || '非会员' }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="model_level"  label="模型身份" align="left">
                <template slot-scope="scope">
                    <!-- 定义映射对象，key是身份值，value包含文字和颜色 -->
                    <span :style="{ color: {1:'#000',2:'#f56c6c',3:'#c0c4cc'}[scope.row.model_level] || '#c0c4cc' }">
                    {{ {1:'会员中',2:'已过期',3:'非会员'}[scope.row.model_level] || '非会员' }}
                    </span>
                </template>
            </el-table-column>

          </el-table>
        </div>
      </div>
    </div>


     <el-dialog :visible.sync="dialogVisible_one" width="1400" custom-class="sousuo" :show-close="false">
        <div style="height:250px;">
          <div>
            <span
              style="width: 69px;border: 1px solid #589ff9;height: 26px;font-size: 12px;line-height: 26px;color: #589ff9;border-radius: 3px;cursor: pointer;display: flex;justify-content: center;margin: 0 40px 30px 90px;"
              @click="cleanUpEvt">ALL</span>
          </div>
          <div style="height:300px;display:flex">
            <div>
              <div class="all_input">
                <span>昵称</span>
                <el-input style="width: 125px;margin-left:5px;border:1px solid  #858585" size="mini" placeholder="昵称"  clearable
                @change="getList"  v-model="username" ></el-input>
              </div>
            </div>
            <div>
                <div class="all_input">
                    <span>收入时间</span>
                    <el-date-picker v-model="value2" type="daterange" start-placeholder="收入时间" value-format="timestamp"
                    end-placeholder="" align="right" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd"
                    range-separator="-" style="width: 125px;" @change="getList"
                    :class="{ 'your-css-class_box': !isValue2Empty_box }" class="border_box">
                    </el-date-picker>
                </div>
                <div  style="border:none">
                    <compress-size-input  style="border:none;font-size:12px" :class="xiazai_shu == '' ? 'blue' : 'orange'" v-model="xiazai_shu"
                    class="my-compress-input" @update="handleUpdate('xiazai_shu', $event)" label="收入金额" ref="compressPopover3"
                      placeholder="请输入范围"></compress-size-input>
                </div>
            </div>
          </div>
        </div>
      </el-dialog>
  </div>
</template>
<script>

import { AdminIcoMeLabelApi , editListApi } from "../../../apis/income";


import CompressSizeInput from '@/components/CompressSizeInput.vue';
const delay = (function () {
    let timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();
export default {
    components: {
        CompressSizeInput,
    },
    data() {
        return {
            xiazai_shu: '',

            header: true,
            src: "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
            //备注
            remtInput: "",
            authorIdInput: "",
            localInput: "",
            last_login: "",
            //分页输入框数据
            paginationInput: 96,
            currentPage1: 1,
            type: 4,
            //分页总数据
            total: null,
          

            RechargeName: "请选择",
            pickerOptions: {
                shortcuts: [
                    {
                        text: "今天",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            picker.$emit("pick", [
                                new Date(start.setHours(0, 0, 0, 0)),
                                new Date(end.setHours(23, 59, 59, 0))
                            ]);
                        }
                    },
                    {
                        text: "本周",
                        onClick(picker) {
                            const current = new Date();
                            let nowDayOfWeek = current.getDay();
                            if (nowDayOfWeek === 0) nowDayOfWeek = 7;
                            const dayNum = 1 * 24 * 60 * 60 * 1000;
                            const firstDate = new Date(
                                current.valueOf() - (nowDayOfWeek - 1) * dayNum
                            );
                            const lastDate = new Date(
                                new Date(firstDate).valueOf() + 6 * dayNum
                            );
                            // picker.$emit("pick", [firstDate, lastDate]);
                            picker.$emit("pick", [
                                new Date(firstDate.setHours(0, 0, 0, 0)),
                                new Date(lastDate.setHours(23, 59, 59, 0))
                            ]);
                        }
                    },
                    {
                        text: "当月",
                        onClick(picker) {
                            const date = new Date();
                            const year = date.getFullYear();
                            const month = date.getMonth();
                            let thisMonthStartDate = new Date(year, month, 1);
                            let thisMonthEndDate = new Date(year, month + 1, 0);
                            // picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
                            picker.$emit("pick", [
                                new Date(thisMonthStartDate.setHours(0, 0, 0, 0)),
                                new Date(thisMonthEndDate.setHours(23, 59, 59, 0))
                            ]);
                        }
                    },
                    {
                        text: "当年",
                        onClick(picker) {
                            var tYear = new Date().getFullYear();
                            var startTime = new Date(tYear, 0, 1); //当前年第一天
                            var endTime = new Date(tYear, 11, 31); //当前年最后一天
                            // picker.$emit("pick", [startTime, endTime]);
                            picker.$emit("pick", [
                                new Date(startTime.setHours(0, 0, 0, 0)),
                                new Date(endTime.setHours(23, 59, 59, 0))
                            ]);
                        }
                    },
                    {
                        text: "昨天",
                        onClick(picker) {
                            const temp = new Date();
                            temp.setTime(temp.getTime() - 3600 * 1000 * 24);
                            picker.$emit("pick", [
                                new Date(temp.setHours(0, 0, 0, 0)),
                                new Date(temp.setHours(23, 59, 59, 0))
                            ]);
                        }
                    },
                    {
                        text: "上周",
                        onClick(picker) {
                            const current = new Date(
                                new Date().getTime() - 60 * 60 * 24 * 7 * 1000
                            );
                            let nowDayOfWeek = current.getDay();
                            let diffToMonday =
                                current.getDate() -
                                nowDayOfWeek +
                                (nowDayOfWeek === 0 ? -6 : 1);
                            const firstDate = new Date(current.setDate(diffToMonday));
                            const lastDate = new Date(current.setDate(diffToMonday + 6));
                            picker.$emit("pick", [
                                new Date(firstDate.setHours(0, 0, 0, 0)),
                                new Date(lastDate.setHours(23, 59, 59, 0))
                            ]);

                            // picker.$emit("pick", [firstDate, lastDate]);
                        }
                    },
                    {
                        text: "上月",
                        onClick(picker) {
                            var now = new Date();
                            var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
                            var ed = new Date(now.getFullYear(), now.getMonth(), 0);
                            picker.$emit("pick", [fd, ed]);
                        }
                    },
                    {
                        text: "去年",
                        onClick(picker) {
                            var tYear = new Date().getFullYear() - 1;
                            var startTime = new Date(tYear, 0, 1);
                            var endTime = new Date(tYear, 11, 31); //当前年最后一天
                            picker.$emit("pick", [startTime, endTime]);
                        }
                    }
                ]
            },
            laiyuan: null,
            input: "",
            editShowInp: null,
            editName: null,
            tableData: [],
            totalRow: null,
            //排序
            order: null,
            orField: null,
            activeId: null,
            deleteVisible: false,
            data: {},
            num: null,
            count: 0,
            pagefenye: false, //点击分页 滚动条为0
            loading: false,
            value2: "",
            value1: "",
            value3: "",
            value4: "",
            value5: "",
            isValue2Empty_box: true,
            isValue1Empty_box: true,
            isValue3Empty_box: true,
            isValue4Empty_box: true,
            isValue5Empty_box: true,
            dataLoaded: false, // 表格数据是否加载完成的状态
            c: 1,
            username:null,
            user:null,
            name:null,
            Members:null,
            NewAi:null,
            dialogVisible_one:false,
            isSaving: false, // 标记是否正在保存，防止重复提交
            zonghe:null,
            price: null
        };
    },
    created() {
        this.loading = true;
         if (this.$store.getters.location == '') {
            this.c = 1
        }


     this.c = this.$store.getters.location;

        AdminIcoMeLabelApi({ c: this.c,kind:1,}).then(res => {
            this.tableData = res.data.order;
            this.total = res.data.count;
            this.zonghe = res.data.total
            this.amount_total = res.data.amount_total;
            this.user_total = res.data.user_total;
            // this.paginationInput = res.data.limit
            this.loading = false;
        });
        //监听鼠标按下抬起事件
        window.addEventListener("keydown", this.handKeyCode, true);
        window.addEventListener("keyup", this.handKeyEvt);

        const storedDateRange = sessionStorage.getItem('dateRange');
        if (storedDateRange) {
            const dateRange = JSON.parse(storedDateRange);
            // 将秒转换回毫秒
            this.value2 = [dateRange.start * 1000, dateRange.end * 1000];
            // 可以在这里调用 getList() 方法，使用存储的日期信息进行数据加载
            this.getList();
        }

    },
    beforeDestroy() {
        // 在组件生命周期结束的时候销毁
        window.removeEventListener("keydown", this.handKeyCode, false);
        window.removeEventListener("keyup", this.handKeyEvt, false);
    },
    mounted() {
        //监听页面滚动条事件
        window.addEventListener("scroll", e => this.imgScrollEvt(e), true);
        this.c = this.$store.getters.location;

    },
    methods: {
        handleUpdate(key, value) {
         this.price= this.parseSizeRange(this.xiazai_shu)
         this.getList()
        },
         // 解析大小范围的辅助函数
    parseSizeRange(sizeValue) {
      if (Array.isArray(sizeValue)) {
        return sizeValue;
      }
      if (typeof sizeValue === 'string') {
        // 清理输入中的多余空格
        sizeValue = sizeValue.trim();

        // 特别针对 "1111 - MB" 格式的输入
        const rangeWithUnitMatch = sizeValue.match(/^(\d+)\s*-\s*(\w+)$/);
        if (rangeWithUnitMatch) {
          const number = parseInt(rangeWithUnitMatch[1], 10);
          const unit = rangeWithUnitMatch[2];
          return [`${number}`, '', unit]; // 返回 [数值, 空字符串, 单位]
        }
        // 支持单边范围, 如 "111 -" 或 "- 15"
        const regexSingle = /^(\d+)\s*-\s*$|^-\s*(\d+)(?:\s+(\w+))?$/;
        let match = sizeValue.match(regexSingle);
        if (match) {
          const unit = match[3] || ''; // 不再默认为'KB'
          if (match[1]) { // 表示最小值
            const singleNumber = parseInt(match[1], 10);
            return [`${singleNumber}`, '', unit];
          } else if (match[2]) { // 表示最大值
            const singleNumber = parseInt(match[2], 10);
            return ['', `${singleNumber}`, unit];
          }
        }
        // 检查是否是简单的数字输入（例如 "111" 或 "111 KB"）
        const singleNumberMatch = sizeValue.match(/^(\d+)(?:\s+(\w+))?$/);
        if (singleNumberMatch) {
          const number = parseInt(singleNumberMatch[1], 10);
          const unit = singleNumberMatch[2] || ''; // 不再默认为'KB'
          return [`${number}`, '', unit];
        }

        // 原有的多条件匹配逻辑...
        const regex = /^(\d+)\s*([<>=])\s*(\d+)(?:\s+(\w+))?$/;
        match = sizeValue.match(regex);

        if (match) {
          const [_, num1, operator, num2, unit] = match;
          const parsedNum1 = parseInt(num1, 10);
          const parsedNum2 = parseInt(num2, 10);

          if (operator === '=') {
            if (parsedNum1 !== parsedNum2) {
              console.warn('Invalid input: Numbers on both sides of "=" must be equal.');
              return null;
            }
            return [`${parsedNum1}`, `${parsedNum1}`, unit || '']; // 如果没有单位，则为空字符串
          } else {
            const min = Math.min(parsedNum1, parsedNum2);
            const max = Math.max(parsedNum1, parsedNum2);
            return [`${min}`, `${max}`, unit || '']; // 如果没有单位，则为空字符串
          }
        }
      }

      const singleNumber = parseInt(sizeValue, 10);
      if (!isNaN(singleNumber)) {
        return [`${singleNumber}`, '', '']; // 不再默认为'KB', 第二个值为空字符串
      }
      return ['', '', '']; // 如果无法解析，返回两个空字符串和空的单位
    },



          //显示修改输入框
          editShowEvt(e, s) {
            console.log(e,321);
                this.editShowInp = e.id;
                this.editName = s;
                this.$nextTick(_ => {
                    this.$refs.editInput.$refs.input.focus();
                });
            },
        saveRemark(id) {
            // 如果正在保存，直接返回，避免重复调用
            if (this.isSaving) return;

            this.isSaving = true;
            editListApi({
                id: id,
                field: this.editName,
                val: this.$refs.editInput.nativeInputValue ,
            }).then((res) => {
                this.editShowInp = null;
            }).finally(() => {
                // 无论成功失败，都重置保存标记
                this.isSaving = false;
            });
        },
        tnachuang(){
            this.dialogVisible_one = true
        },
       


        //分页只显示前三页加总数
        showTotal(total) {
            return `共 ${total} 页`;
        },
        //按下键盘事件
        handKeyCode(e) {
            e = e || window.event;
        },

        limitEvt() {
            this.getList();
        },
        //滑动事件
        imgScrollEvt(e) {
            var e =
                document.documentElement.scrollTop ||
                window.pageYOffset ||
                e ||
                document.body.scrollTop;
            //点击分页 滚动条为0
            if (this.pagefenye == true) {
                e.scrollTop = 0;
                this.pagefenye = false;
                return;
            }
        },
        //分页
        handleCurrentChange(res) {
            this.loading = true;
            setTimeout(() => {
                this.getList();
                this.loading = false;
            }, 500);
        },
        //
        rowStyle({ row, column, rowIndex, columnIndex }) {
            if (column.label == "等级") {
                return {};
            } else if (column.label == "昵称") {
                return {};
            }
        },
        //列表排序
        sortChangeEvt(row) {
            if (row.order == "ascending") {
                this.order = "asc";
            } else if (row.order == "descending") {
                this.order = "desc";
            }
            this.orField = row.prop;
            this.getList();
        },
      
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                for (let key in this.total) {
                    if (column.property == key) {
                        sums[index] = this.total[key];
                    }
                }
                if (index === 0) {
                    sums[index] = this.zonghe;
                    return;
                } else if (index === 1) {
                    sums[index] = this.amount_total;
                    return;
                }else if (index === 3) {
                    sums[index] = this.user_total;
                    return;
                }
            });
            return sums;
        },
        //点数情况
        RechargeEvt(res) {
            switch (res) {
                case "4":
                    this.RechargeName = "会员购买";
                    break;
                case "5":
                    this.RechargeName = "购买点数";
                    break;
                case "6":
                    this.RechargeName = "AI充值";
                    break;
            }
            this.recharge = res;
            this.getList();
        },
        //按下键盘事件
        handKeyCode(e) {
            e = e || window.event;
            //Page Up 翻页
            if (e.keyCode == 34) {
                if (this.allLabel == true) {
                    return;
                }
                if (
                    this.dialogVisible == true ||
                    this.searchLabelDialog == true ||
                    this.rightLabelDialog == true ||
                    this.deleteVisible == true ||
                    this.uploadVisible == true
                ) {
                    e.preventDefault();
                    this.arrowRightEvt()
                    this.inputValue_box = ''
                    return;
                }
                this.loading = true
                e.preventDefault();
                delay(() => {
                    this.currentPage1++;
                    this.getList()
                }, 300);
            }
            // Page Down向后分页
            if (e.keyCode == 33) {
                this.loading = true
                delay(() => {
                    if (this.currentPage1 <= 1) {
                        this.currentPage1 = 1;
                    } else {
                        this.currentPage1--;
                    }
                    this.getList()
                }, 300);
            }
        },

            getList() {
                    // 处理 value2（例如：下单时间）
                    let date2 = {};
                    if (this.value2 && this.value2.length === 2) {
                        date2 = {
                            start: Math.floor(this.value2[0] / 1000), // 毫秒转秒
                            end: Math.floor(this.value2[1] / 1000)
                        };
                        // 将日期信息存入 sessionStorage
                        sessionStorage.setItem('dateRange', JSON.stringify(date2));
                    }


                  

                    // 构造请求参数
                    const params = {
                        // 下单时间
                        start: date2.start || '',
                        end: date2.end || '',

                        // 其他参数...
                        type: this.recharge,
                        page: this.currentPage1,
                        orField: this.orField,
                        orWhere: this.order,
                        limit: this.paginationInput,
                        username: this.username,
                        c: this.c,
                        user: this.user,
                        name: this.name,
                        Members: this.Members,
                        NewAi: this.NewAi,
                        // 核心修改：先判断 this.price 是否为有效数组，再取索引，否则赋值为空字符串
                        money_start: Array.isArray(this.price) ? (this.price[0] || '') : '',
                        money_end: Array.isArray(this.price) ? (this.price[1] || '') : '',
                        kind:1,
                    };

                    // 发起请求
                    AdminIcoMeLabelApi(params).then(res => {
                        this.tableData = res.data.order;
                        this.total = res.data.count;
                        this.amount_total = res.data.amount_total;
                        this.user_total = res.data.user_total;
                        this.zonghe = res.data.total

                        this.pagefenye = true;
                        let as = document.querySelector('.el-table__body-wrapper');
                        as.scrollTop = 0;
                        this.imgScrollEvt(as);
                        this.loading = false;
                        this.dataLoaded = true;
                    });
                },
        //清除搜索条件
        cleanUpEvt() {
            this.authorIdInput = "";
            this.remtInput = "";
            this.value2 = "";
            this.RechargeName = "请选择";
            this.currentPage1 = 1;
            this.username = ''
            this.xiazai_shu = "";
            this.price = "";
            this.$refs.sortTable.clearSort();
            sessionStorage.removeItem('dateRange');
            AdminIcoMeLabelApi({ c: this.c,kind:1,}).then(res => {
                this.tableData = res.data.order;
                this.paginationInput = 96;
                this.total = res.data.count;
                this.zonghe = res.data.total

                this.amount_total = res.data.amount_total;
                this.user_total = res.data.user_total;
                this.pagefenye = true;  //点击分页 滚动条为0
                let as = document.querySelector('el-table__body-wrapper is-scrolling-none')
                this.imgScrollEvt(as);
            });
        },
        clearEvt1() {
            this.RechargeName = "请选择";
            AdminIcoMeLabelApi({ c: this.c,kind:1,}).then(res => {
                this.tableData = res.data.order;
                this.paginationInput = res.data.limit;
                this.currentPage1 = res.page;
                this.zonghe = res.data.total
                this.total = res.data.count;
                this.totalRow = res.totalRow;
                this.amount_total = res.data.amount_total;
                this.user_total = res.data.user_total;
            });
        }
    },
    //点击X后清理数据后并更改值
    computed: {},
    watch: {
      '$store.getters.location': function (newLocation, oldLocation) {
          this.c = newLocation
        },
        value2: function (newVal, oldVal) {
            this.isValue2Empty_box = !newVal;
        },
        value1: function (newVal, oldVal) {
            this.isValue1Empty_box = !newVal;
        }
    }
};
</script>

<style lang="less"  scoped>
@import url("../../../style/space.less");
@import url("../../../style/income.less");

/deep/.el-table th.el-table__cell{
  background: #F5F7FA !important;
}
.item {
    margin-top: 10px;
}

/deep/.el-input__suffix {
    color: #409eff;
}

/deep/.el-main {
    overflow: unset !important;
}

.search_box {
    position: absolute;
    top: 20px;
    left: 50px;
    width: 320px;
    height: 470px;
    border-radius: 10px;
    background-color: #fff;
    display: flex;
    justify-content: space-evenly;
    z-index: 999;
    flex-direction: column;
    justify-content: space-evenly;
    padding: 20px 10px;
    box-shadow: 0 0 10px 1px #e5e5e5;

    /*visibility: hidden;*/
    .num_box {
        width: 127px;
        border: 1px solid #e4e3e3;
        border-radius: 3px;
        margin-top: 5px;
    }
}

.all_text {
  background-color: #409eff;
  font-size: 13px;
  color: #fff;
  cursor: pointer;
  height:26px;
  border-radius: 3px;
  width: 50px;
  text-align: center;
  line-height: 26px;
}

.caoz {
    margin-top: 8px;
    display: flex;
}

/* .block {
      position: absolute;
      margin-top: 9px;
      top: 0;
      right: 1%;
      transition: all 0.2s ease 0.5s;
    } */


.block1 {
    visibility: hidden;
}

.block1>div {
    display: none;
}

.clear {
    position: relative;
    height: 50px;

    span:nth-last-child(1) {
        background-color: #fff;
        border: 1px solid #e5e5e5;
        font-size: 13px;
        color: #c4c3c3;
        border-radius: 3px;
        position: absolute;
        right: 5px;
        bottom: -6px;
        padding: 0 10px;
        cursor: pointer;
    }
}

.demo-table-expand {
    background-color: #f2f2f2;
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    padding: 0 20px;
    width: 30%;
}

.name_box {
    display: flex;
    justify-content: left;
    align-items: center;
    width: 100%;

    i {
        cursor: pointer;
        display: none;
    }
}

.name_box:hover>i {
    display: block;
}

.pagination_box {
    min-width: 500px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.num_box button {
    width: 158px;
    border: 1px solid #858585;
    background-color: #fff;
    color: #c4c3c3;
    height: 37px;
}

.rowClassOne {
    background-color: #e7ecff;
}

.rowClassTwo {
    color: #222222;
    background-color: #1c43ce;
}

.rowClassThree {
    background-color: #6a88f1;
}

.el-dropdown-link {
    cursor: pointer;
}

.notes_box {
    height: 72px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.my-icon {
    cursor: pointer;
    width: 25px;
}

/deep/.el-table thead {
    font-size: 12px;
}
/deep/.el-table__footer-wrapper {
    position: fixed;
    top: 115px;
    z-index: 111;
}

/deep/.el-table__fixed-footer-wrapper {
    display: none;
}

/deep/.el-badge__content.is-fixed {
    display: none;
}

/deep/.el-input__inner {
    color: #409eff;
    cursor: pointer;
}

.clear_ev {
    position: absolute;
    right: 10px;
}

.vip-button {
    color: #000 !important;
    background-color: #bcd9f8d4 !important;
}
/deep/.vip .el-input__inner {
  background-color: #bcd9f8d4 !important;
  color: #000;
}
/deep/.gutter {
    background: #F5F7FA !important;
}

/* 朝上排序样式 */
/deep/.el-table .ascending .sort-caret.ascending {
    background-color: #f00 !important;
    background: url("../../../img/12.png") no-repeat -4px -3px  !important;
    background-size: 11px 14px !important;
    width: 40px;
    height: 58px;
    z-index: 11;
}

/* 朝下排序样式 */
/deep/.el-table .descending .sort-caret.descending {
    background: url("../../../img/22.png") no-repeat -5px 2px !important;
    background-size: 11px 14px !important;
    width: 40px;
    height: 25px;
}

/deep/.el-table .descending .sort-caret.descending {
    border-top-color: #fff;
}

  /* 朝上字体样式 */
  /deep/.el-table__header .ascending  .cell{
    color: #409EFF !important;
  }
  /* 朝下字体样式 */
  /deep/.el-table__header .descending  .cell{
    color: #409EFF !important;
  }

.orange {
    /deep/.el-input__inner {
        background-color: #bcd9f8d4 !important;
        color: #222222;
    }

    /deep/.el-input__suffix {
        color: #222222;
    }
}

.your-css-class {
    background-color: #bcd9f8d4 !important;
    z-index: 9999;

    input {
        background-color: #bcd9f8d4 !important;
    }
}

.your-css-class_box {
    background-color: #bcd9f8d4 !important;

    input {
        background-color: #bcd9f8d4 !important;
    }
}

.orange {
    /deep/.el-input__inner {
        background-color: #bcd9f8d4 !important;
        color: #222222;
    }

    /deep/.el-input__suffix {
        color: #222222;
    }
}


//调整日期选择器的盒子大小进行修改
/deep/.el-range-editor--mini{
    height: 28px !important;
  }
  .all_input {
  margin-top: 10px;
  margin-left: 15px;
  display: flex;
  align-items: center;

  span {
    width: 55px;
    font-size: 11px;
    text-align: end;
    margin-right: 10px;
  }

  .el-input {
    width: 160px;
    height: 40px;
    border-radius: 5px;
  }

  .el-select {
    border: 1px solid;
    border-radius: 5px;
  }

  /deep/.el-input__icon {
    line-height: 30px !important;
    cursor: pointer;
  }
}
.all_input_ect {
  /deep/.el-input__icon {
    line-height: 18px !important;
    cursor: pointer;
    margin-left: -15px !important;
  }
}
/deep/.sousuo .el-input__inner {
  height: 38px !important;
  cursor: pointer;
}
/deep/.sousuo .el-dialog__header{
  padding: 0px 20px 10px !important;
}
/deep/.sousuo{
  border-radius: 8px !important;
}

/deep/ .el-input .el-input__clear:hover{
color: #f00 !important;
}
/deep/ .el-date-editor .el-range__close-icon{
color: #f00 !important;
}
/deep/.el-select .el-input .el-icon-circle-close{
  color: #f00 !important;
}

/deep/.el-table th.el-table__cell{
    background: #F5F7FA !important;
    padding: 0 !important;
  }
//   /deep/.el-table__fixed-body-wrapper {
//     overflow-y: scroll !important;
//     height: calc(100vh - 255px) !important;
//   }


/deep/.source_ID{
      margin-left: 15px !important;
    }


/deep/.my-compress-input .input_e {
  width: 125px !important; /* 改成你想要的宽度 */
}
/* 修改 placeholder 字体大小 */
/deep/ .my-compress-input .input_e input::placeholder {
  font-size: 11px !important;
}
</style>
<style>
.your-css-class .el-range-input {
    background-color: #8fc6ff00 !important;
}

.your-css-class_box .el-range-input {
    background-color: #8fc6ff00 !important;
}

.selt {
    color: #909399 !important;
}

::placeholder {
    color: #858585 !important;
}

.border_box {
    border: 1px solid #858585 !important;
    border-radius: 5px
}
</style>



// WEBPACK FOOTER //
// src/income/components/income_box/index.vue